import { render, staticRenderFns } from "./IconFontawesome.vue?vue&type=template&id=efb4d3ec&scoped=true&"
import script from "./IconFontawesome.vue?vue&type=script&lang=js&"
export * from "./IconFontawesome.vue?vue&type=script&lang=js&"
import style0 from "./IconFontawesome.vue?vue&type=style&index=0&id=efb4d3ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb4d3ec",
  null
  
)

export default component.exports